export default __webpack_public_path__ + "static/media/type_04_drk@60.7d419f2f.svg";